<template>
  <div class="topic-type single-topic">
    <div class="topic-container">
      <topic-info :info="info" />
      <div class="operation">
        <div class="list">
          <div class="item" :class="{ active: answerRecord[0] && answerRecord[0].key === item.key }" v-for="(item, index) in info.p_list" :key="index" @click="handleSelect(item)">
            <div class="name">{{item.content}}</div>
          </div>
          <div class="zw" v-for="(i, ind) in 3" :key="'zw' + ind"></div>
        </div>
        <div class="explain" v-if="info.explain">
          <p><span>说明：</span>{{ info.explain }}</p>
        </div>
      </div>
    </div>
    <!-- 指令 -->
    <div class="instruction-container" v-if="info.edict">
      <div class="content" :class="{open: instructionShow}">
        <p v-show="instructionShow">{{ info.edict }}</p>
        <van-icon name="arrow-left" v-show="instructionShow" @click="instructionShow = false" />
      </div>
      <div class="btn" @click="instructionShow = true">
        <img src="@/assets/img/instruction.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import TopicInfo from "../TopicInfo";
export default {
  name: "SingleTopic",
  components: {
    TopicInfo
  },
  props: {
    value: {
      type: [Number, String],
      default: ""
    },
    topicInfo: {
      type: Object,
      required: true
    },
    isHand: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      info: {},
      score: 0,
      instructionShow: false,
      answerRecord: []
    }
  },
  watch: {
    value: {
      handler(val) {
        this.score = val;
      },
      immediate: true
    }
  },
  created() {
    this.info = this.$route.query.topic_sort * 1 > 0 ? this.topicInfo.topic_info : this.topicInfo;
    // 初始化答题记录
    if (this.topicInfo.son_toprecrd) {
      this.answerRecord = JSON.parse(JSON.stringify(this.topicInfo.son_toprecrd));
    }
  },
  methods: {
    handleSelect(item){
      this.$set(this.answerRecord, 0, item);
      if (this.isHand) {
        this.$emit('update:isHand', false);
      }
      this.$nextTick(() => {
        this.calculateScore();
      })
    },
    // 计算分数
    calculateScore() {
      if (this.isHand) return;
      if (this.answerRecord.length === 0) {
        this.score = '';
      } else {
        let key = this.answerRecord[0].key;
        if (this.info.full_mark.options.includes(key)) {
          this.score = 1;
        } else if (this.info.half_mark.options.includes(key)) {
          this.score = 0.5;
        } else {
          this.score = 0;
        }
      }
      this.$emit('input', this.score);
    },
  },
}
</script>

<style lang="less" scoped>
.operation {
  // height: 3rem;
  flex: 1;
  padding: 0.2rem 0.15rem;
  overflow-y: scroll;
  .list {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 0.2rem;
    .item {
      background: linear-gradient(351deg, #fff6e5 0%, #ffebd4 100%);
      box-shadow: 0 0.03rem 0.06rem 1px rgba(216, 130, 0, 0.38);
      border-radius: 0.1rem;
      border: 1px solid #ffcd94;
      padding: 0.1rem;
      margin-bottom: 0.1rem;
      width: 32%;
      font-size: 0.13rem;
      color: #630200;
      text-align: center;
    }
    .active {
      background: #ffe56f;
      box-shadow: 0 0.03rem 0.06rem 1px rgba(216, 130, 0, 0.52),
        inset 0 0 0.1rem 1px #ff6f00;
      border: none;
    }
    .zw {
      width: 32%;
    }
  }
  .explain {
    line-height: 1.5;
    background: #fff6f6;
    border-radius: 0.1rem;
    border: 1px solid #ffc8c8;
    margin-top: 0.2rem;
    font-size: 0.13rem;
    color: #630200;
    padding: 0.1rem 0.16rem;
    span {
      font-weight: bold;
      color: #bb0400;
    }
  }
}
.instruction-container {
  min-width: 0.46rem;
  height: 0.46rem;
  position: fixed;
  bottom: 1rem;
  left: 0;
  border-radius: 0.23rem;
  .content {
    width: 0;
    height: 0.43rem;
    background: linear-gradient(205deg, #ffecd6 0%, #ffda95 100%);
    border-radius: 0 0.2rem 0.2rem 0;
    border: 1px solid #ffc767;
    font-size: 0.12rem;
    color: #540200;
    line-height: 0.14rem;
    position: absolute;
    left: 0.2rem;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    transition: all 0.1s ease;
    box-sizing: border-box;
    p {
      // 限制最多显示两行
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      word-wrap: break-word;
      word-break: break-all;
    }
    .van-icon {
      color: #f59f0c;
      font-size: 0.14rem;
      margin-left: 0.05rem;
    }
    &.open {
      width: max-content;
      max-width: 3rem;
      padding: 0 0.15rem 0 0.3rem;
    }
  }
  .btn {
    width: 0.46rem;
    height: 0.46rem;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>